/* eslint-disable no-unused-vars */
import React, { PropTypes } from 'react';
import IconButton from 'material-ui/IconButton';
import IconClose from '../Icons/IconClose';
import LoggedAppBar from '../LoggedLayout/LoggedAppBar';
import { catHTML } from '../../utilites/textUtilites';

class AbstractEditForm extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    save: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired
  };

  async save(data) {
    data.short_content = catHTML(data.description, 80);
    try {
      return await this.props.save(this.props.model, data);
    } catch (err) {
      if (err.base) {
        throw { _error: err.base, ...err };
      } else {
        throw err;
      }
    }
  }

  change = (field, value) => {
    this.props.onChange(field, value);
  };

  /**
   * On success submit form
   * @param res
   * eslint no-unused-vars:0
   */
  async formSubmitted(res) {}

  processSubmit = () => {
    let { handleSubmit, values } = this.props;

    return handleSubmit(data => this.save(data))(values).then(response =>
      this.formSubmitted(response),
    );
  };

  publish = () => {
    let { handleSubmit, publish, model, values } = this.props;
    return handleSubmit(data => this.save(data))(values).then(() => {
      publish(model);
    });
  };

  goBack = () => {
    this.props.onClose();
  };

  _renderHeader() {
    let { label } = this.props;

    return (
      <LoggedAppBar
        isStatic={true}
        title={label}
        iconElementRight={
          <IconButton onClick={this.goBack}>
            <IconClose />
          </IconButton>
        }
      />
    );
  }

  render() {
    return <div>AbstractEditForm</div>;
  }
}

export default AbstractEditForm;



// WEBPACK FOOTER //
// ./src/components/common/AbstractEditForm.js